import React from "react";
import { Checkbox, FormControlLabel, Grid } from "@material-ui/core";

export interface CheckboxOptionClasses {
  checkBoxStyle: string;
  checkBoxLabel: string;
  checkBoxLabelBold: string;
}

export interface CheckboxOptionProps {
  checked: boolean;
  name: string;
  title: string;
  description: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  color?: "primary" | "default";
  indeterminate?: boolean;
  classes: CheckboxOptionClasses;
}

const CheckboxOption: React.FC<CheckboxOptionProps> = ({
  checked,
  name,
  title,
  description,
  onChange,
  color = "primary",
  indeterminate = false,
  classes,
}) => (
  <Grid item md={12} xs={12}>
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          classes={{ root: classes.checkBoxStyle }}
          onChange={onChange}
          name={name}
          color={color}
          indeterminate={indeterminate}
        />
      }
      classes={{ label: classes.checkBoxLabel }}
      label={
        <span>
          <p className={classes.checkBoxLabelBold}>{title}</p>
          <p className={classes.checkBoxLabel}>{description}</p>
        </span>
      }
    />
  </Grid>
);

export default CheckboxOption;
